export default "__VITE_ASSET__21ad7135__"